// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"423":"73e8163d","477":"704f3c28","754":"d4388e1c","858":"2d7a4df8"}[chunkId] + ".chunk.js";
};